module.exports = __webpack_public_path__ + "assets/img/6_487_big.8bbe2684.jpg";